import React from "react";
import "./Common.css";

const TextInput = (props) => {
  return (
    <div style={{ position: "relative" }}>
      {props.label && (
        <label className="inputLabel">
          {props.label}
          {props.validate && <span className="common_star_color">*</span>}
        </label>
      )}
      {props.leftIcon && (
        <div className="leftIconCenter">
          <i className={props.leftIcon} aria-hidden="true"></i>
        </div>
      )}
      <input
        style={{
          paddingLeft: props.leftIcon ? 62 : 10,
          borderRadius: props.style ? props.style : 30,
          scrollMarginTop: props?.scroll,
          cursor: props.cursor,
        }}
        id={props.id || ""}
        className="form-control commonTextInputBorder"
        type={props.type || "text"}
        placeholder={props.placeholder || ""}
        value={props.value}
        onChange={props.onChange}
        maxLength={props.maxLength || ""}
        readOnly={props.readOnly || false}
        max={props.max || ""}
        min={props.min || ""}
        onKeyDown={props?.onKeyDown}
      />
      {props.rightIcon && (
        <div className="RightIconCenter" onClick={props.onClick}>
          <i className={props.rightIcon} aria-hidden="true"></i>
        </div>
      )}
    </div>
  );
};

export default TextInput;
